
    import { Component, Vue } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import LeistungenDetail from '@/components/Leistungen/LeistungenDetail.vue';
    import Leistung from '@/types/Leistung';
    import { LeistungenFilter, LoadLeistungenPayload } from '@/store/leistungen';
    import { DataTableHeaders } from '@/types';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        components: {
            LeistungenDetail,
        },
        computed: {
            ...mapState('leistungen', ['leistungen', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('leistungen', ['loadLeistungen']),
            ...mapMutations('leistungen', ['setDialogsDetail']),
        },
    })
    export default class Leistungen extends Vue {
        public loadLeistungen!: (payload: LoadLeistungenPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public leistung = new Leistung();
        public search = '';

        public filter: LeistungenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Leistung> {
            if (this.getSystemEinstellung('muw').isEnabled()) {
                return [
                    {text: '', value: 'actions', sortable: false, width: 50},
                    {text: 'Leistung', value: 'leistung'},
                    {text: 'Bezeichnung', value: 'bezeichnung'},
                    {text: 'Schnellauswahl anzeigen', value: 'aktiv'},
                    {text: 'Aktiv Default', value: 'aktiv_default'},
                    {text: 'Leistung Inkludiert', value: 'leistung_id_inkludiert_bezeichnung'},
                    {text: 'Preis', value: 'preis'},
                    {text: 'Preis Mitarbeiter', value: 'preis_mitarbeiter'},
                    {text: 'Preis Rektorat', value: 'preis_rektorat'},
                    {text: 'Steuersatz', value: 'steuersatz'},
                    {text: 'HCW', value: 'hcw'},
                    {text: 'Gültig', value: 'gueltig'},
                ];
            } else {
                return [
                    {text: '', value: 'actions', sortable: false, width: 50},
                    {text: 'Leistung', value: 'leistung'},
                    {text: 'Bezeichnung', value: 'bezeichnung'},
                    {text: 'Schnellauswahl anzeigen', value: 'aktiv'},
                    {text: 'Aktiv Default', value: 'aktiv_default'},
                    {text: 'Leistung Inkludiert', value: 'leistung_id_inkludiert_bezeichnung'},
                    {text: 'Preis', value: 'preis'},
                    {text: 'Steuersatz', value: 'steuersatz'},
                    {text: 'Gültig', value: 'gueltig'},
                ];
            }
        }

        public mounted(): void {
            this.loadLeistungen({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadLeistungen({ filter: this.filter });
        }

        public onClickEdit(leistung: Leistung): void {
            this.leistung = new Leistung(leistung);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.leistung = new Leistung();
            this.setDialogsDetail(true);
        }
    }
